var React = require('react');

function House (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("polygon",{"points":"47.5,6.013 90.178,48.69 85.891,52.977 47.5,14.585 9.109,52.977 4.822,48.69  ","key":0}),React.createElement("polygon",{"points":"68.74,16.313 77.693,16.313 77.693,33.54 68.74,24.587  ","key":1}),React.createElement("path",{"d":"M47.785,20.3L17.401,50.684v38.303h19.526V65.174h21.145v23.813h19.526V50.114L47.785,20.3z M54,49.915c0,2.2-1.8,4-4,4h-5   c-2.2,0-4-1.8-4-4v-5c0-2.2,1.8-4,4-4h5c2.2,0,4,1.8,4,4V49.915z","key":2})]));
}

House.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 95 95","enableBackground":"new 0 0 95 95","xmlSpace":"preserve"};

module.exports = House;

House.default = House;
